import styled from 'styled-components'
import { colors, derivedColors } from '../../../const'

export const Container = styled.div`
  background-color: ${derivedColors.subtleSurface};
  border: 1px solid ${colors.borderSubtle};
  border-radius: 8px;
  margin: 18px 14px 24px;
  padding: 24px;
`

export const Title = styled.h3`
  color: ${colors.textSecondary};
  font-family: 'Inter';
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 18px;
`

export const Icon = styled.img`
  cursor: pointer;
  height: 18px;
  width: 18px;
`

export const NodeList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 24px;
`

export const NodeItem = styled.div`
  background-color: ${colors.surface};
  border: 1px solid ${colors.borderSubtle};
  border-radius: 6px;
  padding: 14px 16px;
  font-size: 0.875rem;
  font-family: 'Inter';
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`

export const NodeInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const ActionsContainer = styled.div`
  display: flex;
  gap: 20px;
`

export const NodeName = styled.span`
  font-weight: 600;
  color: ${colors.textSecondary};
`

export const NodeEmail = styled.span`
  font-size: 0.75rem;
  color: ${colors.textSecondary};
`

export const EmptyMessage = styled.p`
    font-size: 0.875rem;
    color: ${colors.textSecondary};
    font-style: italic;
`
